/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__included_costs = /** @type {(inputs: { tollCost: NonNullable<unknown> }) => string} */ (i) => {
	return `davon ${i.tollCost} Maut`
};

const en_route__included_costs = /** @type {(inputs: { tollCost: NonNullable<unknown> }) => string} */ (i) => {
	return `including ${i.tollCost} for tolls`
};

const es_route__included_costs = /** @type {(inputs: { tollCost: NonNullable<unknown> }) => string} */ (i) => {
	return `incluido ${i.tollCost} de peajes`
};

const fr_route__included_costs = /** @type {(inputs: { tollCost: NonNullable<unknown> }) => string} */ (i) => {
	return `dont ${i.tollCost} de péages`
};

const it_route__included_costs = /** @type {(inputs: { tollCost: NonNullable<unknown> }) => string} */ (i) => {
	return `compresi ${i.tollCost} di pedaggio`
};

const nl_route__included_costs = /** @type {(inputs: { tollCost: NonNullable<unknown> }) => string} */ (i) => {
	return `waarvan ${i.tollCost} tol`
};

const pt_route__included_costs = /** @type {(inputs: { tollCost: NonNullable<unknown> }) => string} */ (i) => {
	return `dos quais ${i.tollCost} de portagens`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ tollCost: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__included_costs = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__included_costs(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__included_costs", locale)
	if (locale === "de") return de_route__included_costs(inputs)
	if (locale === "en") return en_route__included_costs(inputs)
	if (locale === "es") return es_route__included_costs(inputs)
	if (locale === "fr") return fr_route__included_costs(inputs)
	if (locale === "it") return it_route__included_costs(inputs)
	if (locale === "nl") return nl_route__included_costs(inputs)
	return pt_route__included_costs(inputs)
};